import { createSlice } from '@reduxjs/toolkit'
import { addFavourite, removeFavourite, listFavourite, listFavouriteIds } from '../actions/favouriteActions'

const FavouriteReducers = createSlice({
    name: 'FavouriteReducers',
    initialState: {
        loader: false,
        errors: null,
        favourites: null,
        favouriteIds: [],
    },
    reducers: {
        /**
         * Clear Favourites
         */
        clearFavourites(state) {
            state.favourites = null;
            state.favouriteIds = [];
            state.loader = false;
            state.errors = null;
        }
    },
    extraReducers: (builder) => {
        builder
            /**
             * Add Favourite
             */
            .addCase(addFavourite.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(addFavourite.fulfilled, (state, action) => {
                state.loader = false;
                // Optionally update favouriteIds if needed
            })
            .addCase(addFavourite.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            })

            /**
             * Remove Favourite
             */
            .addCase(removeFavourite.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(removeFavourite.fulfilled, (state, action) => {
                state.loader = false;
                // Optionally update favouriteIds if needed
            })
            .addCase(removeFavourite.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            })

            /**
             * List Favourite Products
             */
            .addCase(listFavourite.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(listFavourite.fulfilled, (state, action) => {
                state.loader = false;
                // Handle paginated response structure
                if (action.payload && action.payload.products) {
                    state.favourites = action.payload.products;
                } else {
                    state.favourites = action.payload;
                }
            })
            .addCase(listFavourite.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            })

            /**
             * List Favourite IDs
             */
            .addCase(listFavouriteIds.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(listFavouriteIds.fulfilled, (state, action) => {
                state.loader = false;
                state.favouriteIds = action.payload.products || [];
            })
            .addCase(listFavouriteIds.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            })
    }
});

export const { clearFavourites } = FavouriteReducers.actions;

export default FavouriteReducers.reducer